import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=49b1e532&scoped=true&"
var script = {}
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=49b1e532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1e532",
  null
  
)

export default component.exports